export default "__VITE_ASSET__Dn$NkfMY__"